import { render, staticRenderFns } from "./histDeal.vue?vue&type=template&id=7541afc8&scoped=true"
import script from "./histDeal.vue?vue&type=script&lang=js"
export * from "./histDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541afc8",
  null
  
)

export default component.exports